import React from 'react';
import {
  COLORS,
  SPACING,
  SHADOWS,
  BORDER_RADIUS,
  UI_SCREEN_STYLES,
} from '../../../styles/UISystem';

/**
 * Container Component
 *
 * A standard container for all app pages with consistent styling
 * Features:
 * - Optional header with title and back button
 * - Consistent padding and styling
 * - Content area with proper width constraints
 * - Responsive design
 * - Optional footer
 */
const Container = ({
  title,
  showBackButton = false,
  onBack,
  children,
  footer,
  contentStyle = {},
  showDivider = true,
  maxWidth = '800px',
  backgroundColor = COLORS.WHITE,
}) => {
  return (
    <div
      style={{
        maxWidth,
        margin: '0 auto',
        padding: '20px',
        fontFamily: '-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor,
      }}
    >
      {/* Header with optional back button and title */}
      {title && (
        <div style={UI_SCREEN_STYLES.header}>
          {/* Back button */}
          {showBackButton && onBack && (
            <button onClick={onBack} style={UI_SCREEN_STYLES.backButton}>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M20 11H7.83L13.42 5.41L12 4L4 12L12 20L13.41 18.59L7.83 13H20V11Z"
                  fill="currentColor"
                />
              </svg>
            </button>
          )}

          {/* Title */}
          <h1 style={UI_SCREEN_STYLES.title}>{title}</h1>
        </div>
      )}

      {/* Divider */}
      {showDivider && <div style={UI_SCREEN_STYLES.divider}></div>}

      {/* Content */}
      <div
        style={{
          backgroundColor: COLORS.WHITE,
          padding: '20px',
          borderRadius: BORDER_RADIUS.MD,
          boxShadow: SHADOWS.TIER1,
          flex: 1,
          overflowY: 'auto',
          ...contentStyle,
        }}
      >
        {children}
      </div>

      {/* Footer */}
      {footer && (
        <div
          style={{
            marginTop: SPACING.MD,
            textAlign: 'center',
          }}
        >
          {footer}
        </div>
      )}
    </div>
  );
};

export default Container;
